<template>
  <div class="oneClient">
    <div class="header">
      <div class="title">客源新增</div>
      <div class="closeIcon" @click="close"></div>
    </div>
    <div class="content">
      <div class="part1">
        <div class="oneLine">
          <div><span class="saleRent">购</span></div>
          <div class="mgLeft">姓名</div>
          <input type="text" class="input_150 mgLeft border" v-model="name">
          <select v-model="appellation">
            <option value="先生">先生</option>
            <option value="小姐">小姐</option>
            <option value="女士">女士</option>
          </select>
          <div class="mgX">手机</div>
          <input type="text" class="input_200 border" v-model="phone">
          <button class="check mgX">查</button>
          <div>其它联系方式</div>
          <input type="text" class="input_200 mgX" v-model="other_way">
          <div>来源</div>
          <input type="text" class="input_200 mgX border" v-model="from">
        </div>
        <div>需求：</div>
        <div class="oneLine">
          <div>位置</div>
          <input type="text" class="input_200 mgX border" v-model="position">
          <div>面积</div>
          <input type="text" class="input_100 mgX" v-model="square">
          <div>价格</div>
          <input type="text" class="input_100 mgX" v-model="price">
          <div>户型</div>
          <input type="text" class="input_200 mgX" v-model="room_count">
          <div>装修</div>
          <select class="mgLeft" v-model="decorate">
            <option value="毛坯">毛坯</option>
            <option value="清水">清水</option>
            <option value="简装">简装</option>
            <option value="精装">精装</option>
            <option value="豪装">豪装</option>
          </select>
        </div>
        <div class="oneLine">
          <div>需求提炼</div>
          <input type="text" class="input_500 mgX" v-model="need">
        </div>
      </div>
      <div class="part2">
        <div class="control">
          <div :class="{'active': current_column === '维护', 'common': true}" @click="current_column = '维护'">维护</div>
        </div>
        <div class="notes" v-show="current_column === '维护'">
          <div v-if="noteList.length > 0">
            <div class="note" v-for="oneNote in noteList" :key="oneNote.id">
              <div class="words">
                {{oneNote.words}}
              </div>
              <div class="userAndTime">
                {{oneNote.user + '  ' + oneNote.create_time}}
              </div>
            </div>
          </div>
          <div v-else>
            暂无维护记录
          </div>
        </div>
      </div>
      <div class="part3">
        <div class="left">
          <button @click="showPrompt = true">维护</button>
        </div>
        <div class="right">
          <button @click="save">保存</button>
          <button @click="close">关闭</button>
        </div>
      </div>
    </div>
    <div class="prompt" v-if="showPrompt">
      <div class="prompt-in">
        <textarea cols="70" rows="10" v-model="note"></textarea>
        <div>
            <button @click="addOneNote">保存</button>
            <button @click="cancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['item'],
    data() {
      return {
        client_id: '',
        price: '',
        decorate: '',
        name: '',
        appellation: '',
        phone: '',
        other_way: '',
        from: '',

        square: '',
        position: '',
        room_count: '',
        need: '',

        noteList: [],
        showPrompt: false,
        note: '',
        current_column: '维护'
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        that.$axios.get(that.$url_prefix + 'queryOneClient', {
          params: {
            client_id: that.item.id
          }
        }).then(function (res) {
          console.log('一条客源', res)
          let client = res.data.data;
          that.client_id = client.id
          that.square = client.square
          that.from = client.from
          that.price = client.price
          that.name = client.name
          that.appellation = client.appellation
          that.phone = client.phone
          that.other_way = client.other_way
          that.room_count = client.room_count
          that.decorate = client.decorate
          that.need = client.need
          that.position = client.position
          that.noteList = client.noteList
        }).catch(function (res) {
          console.log('获取一条房源失败', res)
        })
      },
      close() {
        this.$emit('childOper', {
          from: 'oneClient',
          oper: 'close'
        })
      },
      save() {
        let that = this
        if (!that.position || !that.name || !that.phone || !that.client_id) {
          console.log('没有填完整')
          return
        }
        let obj = {
          id: that.client_id,
          square: that.square,
          from: that.from,
          price: that.price,
          name: that.name,
          appellation: that.appellation,
          phone: that.phone,
          other_way: that.other_way,
          room_count: that.room_count,
          decorate: that.decorate,
          need: that.need,
          position: that.position
        }
        let param = {
          'db': 'ClientModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.$emit('childOper', {
            from: 'oneClient',
            oper: 'refresh'
          })
          that.close()
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      addOneNote() {
        let that = this
        let note = that.note.replace(/\s/g, '')
        if (!note) {
          alert('请填写维护内容')
          return;
        }
        let obj = {
          words: that.note,
          client_id: that.client_id,
          user: '小鸡'
        }
        let param = {
          'db': 'NoteModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.init()
          that.showPrompt = false
          that.note = ''
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },
      cancel() {
        this.showPrompt = false
        this.note = ''
      }

    }
  }

</script>

<style scoped>
  input {
    outline: none;
  }

  .mgLeft {
    margin-left: 3px;
  }

  .mgX {
    margin: 0 3px;
  }

  select {
    padding: 1px 3px;
    outline: none;
    background-color: white;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0;
    -webkit-appearance: none;
  }



  .oneClient {
    width: 700px;
    position: fixed;
    z-index: 5;
    box-shadow: 0px 0px 10px rgb(50, 50, 50);
    overflow: hidden;
    font-size: 15px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-60%);
    background-color: white;
  }

  .header {
    background-color: skyblue;
    display: flex;
    padding: 8px;
    justify-content: space-between;
  }

  .title {
    font-weight: 500;
  }

  .closeIcon {
    width: 16px;
    height: 16px;
    background: url('../../static/images/close.png') 0 0 no-repeat;
  }

  .content {
    padding: 8px;
    line-height: 25px;
  }

  .oneLine {
    display: flex;
    align-items: center;
  }

  .saleRent {
    color: white;
    background-color: orange;
    padding: 3px;
    border-radius: 4px;
  }

  .check {
    background-color: orange;
    outline: none;
    padding: 2px;
  }

  .part2 {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid skyblue;
  }

  .part3 {
    margin-top: 10px;
    border-top: 1px solid skyblue;
    display: flex;
    justify-content: space-between;
  }

  .part3 button {
    padding: 3px 10px;
    margin: 10px 5px 5px 0;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }

  .prompt {
    position: absolute;
    z-index: 8;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .prompt-in {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    padding-top: 15px;
    width: 80%;
    margin: 50px auto;
  }

  textarea {
    resize: none;
    margin-top: 20px;
    outline: none;
  }

  .prompt-in button {
    padding: 3px 10px;
    margin: 10px 5px 5px 0;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }


  .input_100 {
    width: 50px;
    height: 15px;
  }

  .input_150 {
    width: 75px;
    height: 15px;
  }

  .input_200 {
    width: 100px;
    height: 15px;
  }

  .input_500 {
    width: 250px;
    height: 15px;
  }

  .border {
    border: 1px solid orange;
    height: 17px;
  }

  .control {
    display: flex;
    /* border-bottom: 1px solid black; */
    box-sizing: border-box;
  }

  .common {
    background-color: skyblue;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    padding: 0 5px;
    box-sizing: border-box;
  }

  .active {
    background-color: white;
    border-bottom: 1px solid transparent;
  }

  .notes {
    margin-top: 5px;
    height: 200px;
    border: 1px solid skyblue;
    overflow-y: auto;
    padding: 5px 10px;
    box-sizing: border-box;
  }

  .note {
    display: flex;
    border-bottom: 1px dashed #cccccc;
    justify-content: space-between;
  }

  .words {
    width: 70%;
  }

  .userAndTime {
    width: 20%;
  }

</style>



// WEBPACK FOOTER //
// src/components/OneClient.vue